<template>
  <div
    class="bg-viewers"
    :hidden="statusPreview"
    @click="handleBackgroundClick"
  >
    <div class="viewers" @click.stop>
      <div
        id="carouselExample"
        class="carousel carousel-dark slide"
        style="width: 100%"
      >
        <div class="carousel-inner">
          <div
            :class="['carousel-item', { active: i === initialIndex }]"
            v-for="(n, i) in datas"
            :key="i"
          >
            <img :src="n.imageurl" class="d-block w-100" alt="..." />
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Sebelumnya</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Selanjutnya</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Carousel } from "bootstrap";
export default {
  computed: {
    ...mapState({
      dataPreview: (state) => state.ImageProduct.dataPreview,
      datas: (state) => state.ImageProduct.datas,
      statusPreview: (state) => state.ImageProduct.statusPreview,
    }),
    initialIndex() {
      // Cari index gambar berdasarkan dataPreview
      return this.datas.findIndex((item) => item.id === this.dataPreview.id);
    },
  },
  methods: {
    handleBackgroundClick(event) {
      // Pastikan elemen yang diklik bukan bagian dari carousel-inner
      if (!event.target.closest(".carousel-inner")) {
        this.$store.commit("ImageProduct/SET_PREVIEW");
      }
    },
  },

  mounted() {
    // Setelah komponen dirender, atur carousel ke slide awal
    const carousel = document.querySelector("#carouselExample");
    const bootstrapCarousel = new Carousel(carousel, {
      interval: false, // Optional, matikan auto-slide
    });
    bootstrapCarousel.to(this.initialIndex); // Atur slide ke index awal
  },
};
</script>

<style scoped>
.bg-viewers {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(92, 92, 92, 0.5);

  /* Flexbox centering */
  display: flex;
  justify-content: center; /* Horizontal center */
  align-items: center; /* Vertical center */
}

.viewers {
  width: 100%;
  max-width: 500px; /* Maximum width of carousel */
  padding: 20px; /* Optional, to provide spacing around the carousel */
}

#carouselExample {
  width: 100%;
  height: 400px;
}

/* Responsiveness */
@media (max-width: 768px) {
  .viewers {
    max-width: 90%;
  }

  #carouselExample {
    height: 300px; /* Adjust height for smaller screens */
  }
}

@media (max-width: 480px) {
  .viewers {
    max-width: 95%;
  }

  #carouselExample {
    height: 250px; /* Adjust height for mobile devices */
  }
}
</style>
